import { VoiceFeedbackWidget } from "./components/voice-feedback-widget";
import { ReactQueryProvider } from "./providers/react-query";
import { VoiceFeedbackWidgetProps } from "./types";

export default function App(props: {
  className: string;
  options: VoiceFeedbackWidgetProps;
}) {
  return (
    <ReactQueryProvider>
      <VoiceFeedbackWidget
        className={props.className}
        options={props.options}
      />
    </ReactQueryProvider>
  );
}
